import React, { useEffect } from "react";
import { Checkbox } from "antd";

import './../../onBoarding/OnBoarding.css';

interface QualificationListProps {
    onQualificationSelect: (qualification: string) => void;
    qualifications: any;
    selectedQualifications: any;
    removeQualification: (qualification: string) => void;
    /**
     * Optional so the list still renders standalone. When absent the "Select all" row is
     * hidden rather than shown as a control that does nothing.
     */
    onToggleSelectAll?: (selectAll: boolean) => void;
}

const QualificationList: React.FC<QualificationListProps> = ({
    onQualificationSelect,
    qualifications,
    selectedQualifications,
    removeQualification,
    onToggleSelectAll,
}) => {

    const handleChange = (e: any, qualification: any) => {
        if (e.target.checked) {
            onQualificationSelect(qualification);
        } else {
            removeQualification(qualification?.code);
        }
    };

    useEffect(() => {
    }, [selectedQualifications]);

    const isSelected = (qualification: any) =>
        selectedQualifications.some((v: any) => v?.code === qualification?.code);

    const selectedCount = qualifications.filter(isSelected).length;
    const allSelected = qualifications.length > 0 && selectedCount === qualifications.length;
    // Drives the dash state, so a partial selection is distinguishable from none at a
    // glance rather than reading as "nothing is selected".
    const someSelected = selectedCount > 0 && !allSelected;

    return (
        <>
            {!!onToggleSelectAll && qualifications.length > 0 && (
                <div className="flex items-center pt-6 pb-3 border-b border-gray-200">
                    <Checkbox
                        checked={allSelected}
                        indeterminate={someSelected}
                        onChange={(e) => onToggleSelectAll(e.target.checked)}
                        className="text-left w-full font-medium text-gray-700"
                    >
                        Select all
                        {selectedCount > 0 ? ` (${selectedCount}/${qualifications.length})` : ""}
                    </Checkbox>
                </div>
            )}

            <ul className="flex flex-col mt-6 w-full text-gray-500">
                {qualifications.map((qualification: any, index: number) => (
                    <li key={index} className={index > 0 ? "mt-6" : ""}>
                        <Checkbox
                            key={"quali" + index}
                            onChange={(e) => handleChange(e, qualification)}
                            checked={isSelected(qualification)}
                            className="text-left w-full hover:text-indigo-600 focus:outline-none focus:text-indigo-600"
                        >
                            {qualification?.code}
                        </Checkbox>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default QualificationList;
